export const LABEL = 'LABEL'
export const PROJECT = 'PROJECT'
export const PRODUCT = 'PRODUCT'
